import React from 'react';
import { matchPath, NavLink, useLocation } from 'react-router-dom';

import { Avatar, List, ListItemText } from '@mui/material';
import Typography from 'components/Typography';
import { ListItemBtnExt, ListItemContent } from './Components';

import { agentConfig, mainConfig } from './SidebarConfig';

import { useAuth } from 'context/AuthContext';
import { colors, tokens } from 'styles';

const DrawerContent = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const match = path =>
    path ? !!matchPath({ path, end: false }, pathname) : false;
  return (
    <>
      <List disablePadding sx={{ marginInline: '24px', marginBlock: '25px' }}>
        <ListItemText>
          <Typography
            token={tokens.FS16FW500LH19_2M}
            color={colors.greyC4}
            text={'Menu'}
            style={{ mb: 1.5 }}
            textAlign='left'
          />
        </ListItemText>
        {user && user.role === 'agent'
          ? agentConfig.map(item => (
              <DrawerItem key={item.path} item={item} active={match} />
            ))
          : mainConfig.map(item => (
              <DrawerItem key={item.path} item={item} active={match} />
            ))}
      </List>
      {/* <List disablePadding sx={{ marginInline: "24px", marginBottom: "25px" }}>
        <ListItemText>
          <Typography
            token={tokens.FS16FW500LH19_2M}
            color={colors.greyC4}
            text={"Others"}
            style={{ mb: 1.5 }}
            textAlign="left"
          />
        </ListItemText>
        {otherConfig.map((item) => (
          <DrawerItem key={item.path} item={item} active={match} />
        ))}
      </List> */}
    </>
  );
};

const activeRootStyle = {
  color: colors.whiteFF,
  backgroundColor: colors.text31,
  '& svg': {
    color: `${colors.whiteFF} !important`
  }
};

function DrawerItem({ item, active }) {
  const { title, path, icon, type } = item;
  const isActiveRoot = active(path);

  return (
    <>
      <ListItemBtnExt
        component={NavLink}
        to={path}
        sx={{
          ...(isActiveRoot && activeRootStyle),
          '&:hover': {
            ...activeRootStyle
          }
        }}
      >
        <ListItemContent>
          {type === 'mui' ? (
            <>{icon}</>
          ) : (
            <Avatar
              src={icon}
              variant='square'
              sx={{
                width: '19px',
                height: '19px',
                '& img': {
                  objectFit: 'contain'
                }
              }}
            />
          )}
          <Typography
            token={tokens.FS18FW500LH21_6M}
            color={isActiveRoot ? colors.whiteFF : colors.greyC4}
            text={title}
            textAlign='left'
            // cursor='pointer'
            style={{
              cursor: 'pointer'
            }}
          />
        </ListItemContent>
      </ListItemBtnExt>
    </>
  );
}

export default DrawerContent;
